import { Box, BoxProps, styled } from '@mui/material';
import { ReactElement } from 'react';

export type PoolCardContentProps = BoxProps;

const StyledBox = styled(Box)(({ theme }) => ({
    ...theme.typography['body1'],
    flex: 1,
    boxSizing: 'border-box',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
}));

export const PoolCardContent = (props: PoolCardContentProps): ReactElement => {
    return <StyledBox {...props} />;
};
